import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './store/authStore';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import CardGeneration from './pages/CardGeneration';
import CardInformation from './pages/CardInformation';
import History from './pages/History';
import Layout from './components/Layout';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <div className="transition-all duration-300 ease-in-out">
                    <Routes>
                      <Route path="/" element={<Navigate to="/card-generation" replace />} />
                      <Route path="/card-generation" element={<CardGeneration />} />
                      <Route path="/card-information" element={<CardInformation />} />
                      <Route path="/history" element={<History />} />
                    </Routes>
                  </div>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
